<template>
  <div class="content">
    <div class="row" style="min-height: 50px;">
      <div class="col-12">
        <div id="commandBarSpotlight"></div>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <!-- your content here -->
      <router-view :key="$route.fullPath"></router-view>
    </transition>
  </div>
</template>
<script>
  export default {}
</script>
<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .15s
  }

  .fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

  {
    opacity: 0
  }
</style>
